// Origin Value for tracking url redirects
export var OfficeDotComOrigin = 'OfficeDotCom';
//# sourceMappingURL=OfficeDotComOrigin.js.map